export const CLEANUP_PARKING_PASSES_STATE = 'cleanup-parking-passes-state';
const cleanupParkingPassesState = () => ({ type: CLEANUP_PARKING_PASSES_STATE });
export default cleanupParkingPassesState;
